import { Component, type ErrorInfo, type ReactNode } from 'react'

/**
 * UN ÉCRAN QUI LÈVE N'EMPORTE PLUS LA COQUILLE.
 *
 * Sans frontière d'erreur, une exception pendant le rendu démonte TOUTE la
 * racine React : barre latérale, en-tête, palette — l'onglet devenait blanc
 * pour une adresse retouchée à la main (`?mois=2026-13` faisait lever
 * `toISOString`, revue du 07/10/2026). La garde entoure le seul contenu de
 * route : la coquille reste, l'écran dit qu'il n'a pas pu s'afficher, et
 * changer de page (menu, Retour) le rend de nouveau — la garde se réarme
 * quand le chemin change, sans remonter les écrans qui changent d'étape sur
 * le même composant.
 *
 * Classe, parce que React n'offre la capture d'erreur de rendu qu'aux classes.
 */
export class GardeEcran extends Component<{ chemin: string; children: ReactNode }, { enPanne: boolean }> {
  override state = { enPanne: false }

  static getDerivedStateFromError(): { enPanne: boolean } {
    return { enPanne: true }
  }

  override componentDidCatch(erreur: unknown, info: ErrorInfo): void {
    // Rien de sensible ici : le message et la pile de composants, pour le diagnostic.
    console.error('[écran en panne]', erreur instanceof Error ? erreur.message : erreur, info.componentStack)
  }

  override componentDidUpdate(avant: { chemin: string }): void {
    if (avant.chemin !== this.props.chemin && this.state.enPanne) this.setState({ enPanne: false })
  }

  override render(): ReactNode {
    if (!this.state.enPanne) return this.props.children
    return (
      <main className="lc-page lc-page--readable">
        <section className="lc-panel" role="alert">
          <div className="lc-panel__head">
            <h1 className="lc-panel__title">Cet écran n’a pas pu s’afficher</h1>
          </div>
          <div className="lc-panel__body">
            <p className="lc-hint">
              Une adresse retouchée ou une donnée inattendue l’a arrêté. Le reste de Gestion fonctionne :
              revenez en arrière, choisissez une page dans le menu, ou rechargez celle-ci.
            </p>
            <button type="button" className="lc-btn" onClick={() => window.location.reload()}>Recharger la page</button>
          </div>
        </section>
      </main>
    )
  }
}
